import axios from "axios";

export default class MortgageService {

    static async getValuationMortgage(authToken) {
        return axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/mortgage`,
            {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            }
        )
    }

    static async createValuationMortgage(authToken, data) {
        return axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/mortgage`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            }
        )
    }
}
